const messages = {
  title: "Over BS Plus",
  description: "About page description",
};

export default {
  messages,
};
